export enum UserWantServiceInFuture {
    TRUE = "Yes",
    FALSE = "No"
}